"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GallerySkeleton = void 0;
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _times = _interopRequireDefault(require("es-toolkit/compat/times"));
var _enums = require("../../models/olapic/enums");
var _styles = require("../OlapicGallery/styles");
var _components = require("./components");
var _LoadMoreSkeleton = require("./components/LoadMoreSkeleton");
var _MediaItemSkeleton = require("./components/MediaItemSkeleton");
var _constants = require("./constants");
var _styles2 = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const GallerySkeleton = ({
  animation = 'pulse',
  className,
  count = _constants.SKELETON_COUNT
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles2.Root, {
    className: className,
    "data-testid": getTestId(_constants.GALLERY_SKELETON),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_components.HeaderSkeleton, {
      animation: animation
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Root, {
      children: (0, _times.default)(count).map((_, index) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_MediaItemSkeleton.MediaItemSkeleton
      // eslint-disable-next-line react/no-array-index-key -- No other option for passing data to key
      , {
        animation: animation,
        position: _enums.MediaItemPosition.gallery
      }, `${_MediaItemSkeleton.MEDIA_ITEM_SKELETON}-${index}`))
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_LoadMoreSkeleton.LoadMoreSkeleton, {
      animation: animation
    })]
  });
};
exports.GallerySkeleton = GallerySkeleton;
